import HomePage from "./homepage"

export default HomePage;